import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';
import { DisposalSet } from '@neptune/cx/utils';

const gc = new DisposalSet();

registerFragment('chroa-bio-banner', (fragmentElement, config, meta) => { });

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
